import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const Testimonials = () => {
  return <section className="mb-10" data-id="element-290">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-291">
        Wat deelnemers ervaren tijdens het webinar
      </h2>
      <div className="space-y-6 mb-6" data-id="element-292">
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-293">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-294">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-295">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1uENzFyeTcPi87ozEBzC5A/Scherm%C2%ADafbeelding_2025-08-15_om_15.51.14.png" alt="Lenneke uit Utrecht" className="w-16 h-16 rounded-full object-cover" data-id="element-296" />
            </div>
            <div data-id="element-297">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-298" />
              <p className="italic" data-id="element-299">
                "Na 20 minuten begreep ik al waarom onze wandelingen altijd
                chaotisch waren. Luna probeerde me de hele tijd te vertellen dat
                ze zich onveilig voelde, maar ik interpreteerde het als
                koppigheid. Het moment dat ik dat doorhad, veranderde alles."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-300">
                - Lenneke uit Utrecht
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-301">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-302">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-303">
              <img src="https://images.unsplash.com/photo-1529429617124-95b109e86bb8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Thomas uit Antwerpen" className="w-16 h-16 rounded-full object-cover" data-id="element-304" />
            </div>
            <div data-id="element-305">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-306" />
              <p className="italic" data-id="element-307">
                "Mijn vrouw en ik keken elkaar halverwege het webinar aan.
                'Daarom doet hij dat!' zeiden we tegelijk. Plotseling maakten
                alle rare gewoontes van Rex perfect zin."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-308">
                - Thomas uit Antwerpen
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-309">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-310">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-311">
              <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Sandra uit Amsterdam" className="w-16 h-16 rounded-full object-cover" data-id="element-312" />
            </div>
            <div data-id="element-313">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-314" />
              <p className="italic" data-id="element-315">
                "Het was emotioneel. Ik realiseerde me dat Buddy mij al maanden
                probeerde iets te vertellen over zijn angst, en ik dacht maar
                dat hij ongehoorzaam was. Ik voelde me schuldig, maar ook
                opgelucht. Eindelijk begreep ik hem."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-316">
                - Sandra uit Amsterdam
              </p>
            </div>
          </div>
        </div>
      </div>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-317">
        De wetenschap achter de snelle transformatie
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-318">
        Psychologisch onderzoek naar "insight learning" toont aan dat mensen
        nieuwe kennis sneller oppikken wanneer ze in één sessie een compleet
        nieuw perspectief krijgen, in plaats van kleine inzichten over een
        langere periode.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-319">
        "Als je iemand leert dat alles wat ze dachten te weten eigenlijk anders
        is, en je geeft ze meteen het juiste kader, dan slaat die kennis direct
        aan," legt Amee uit. "Daarom werkt het webinar-format zo goed voor dit
        onderwerp."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-320">
        Bovendien blijkt dat hondencommunicatie veel logischer en intuïtiever is
        dan mensen denken. "Honden zijn geen mysterieuze wezens," zegt Amee. "Ze
        communiceren helder en consistent. Wij hadden alleen nooit geleerd naar
        hun signalen te kijken."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-321">Daarom werk ik met een webinar.</p>
      <h3 className="text-lg font-bold text-blue-800 mb-4" data-id="element-322">
        Wat is een webinar?
      </h3>
      <p className="mb-6 leading-relaxed" data-id="element-323">
        Een webinar is een online presentatie die je live kunt volgen vanaf je
        telefoon, tablet of computer. Je hoeft nergens naartoe te reizen - je
        volgt gewoon thuis, op kantoor of onderweg via een internetverbinding.
        Tijdens het webinar kun je via de chat vragen stellen aan Amee, en na
        afloop ontvang je automatisch de opname zodat je alles terug kunt kijken
        wanneer het jou uitkomt.
      </p>
    </section>;
};